.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  &.is-error {
    .edit-company-tab-group {
      display: none;
    }

    .edit-company-error {
      display: flex;
    }
  }

  &:not(.is-error) {
    .edit-company-tab-group {
      display: block;
    }

    .edit-company-error {
      display: none;
    }
  }

  .edit-company-tab-group {
    flex: auto;
    padding: 2px;

    --tab-header-padding-left: calc(var(--spacer) * 4);
    --tab-header-padding-right: calc(var(--spacer) * 4);
    --tab-body-padding-left: calc(var(--spacer) * 4);
    --tab-body-padding-right: calc(var(--spacer));
    --tab-body-padding-top: 0;
    --tab-body-padding-bottom: 0;
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .edit-company-tab-group {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}

#company-details-form-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  padding-top: calc(var(--spacer) * 2);

  .form-wrapper {
    min-width: 500px;
    width: 100%;
    height: auto;
    overflow-y: scroll;
  }
}

.bottom-buttons {
  width: 100%;
  flex-basis: 65px;
  min-height: 65px;
  margin-top: auto;
  display: flex;
  align-items: center;

  border-top: 1px solid var(--surface-1);

  gz-button {
    margin-right: calc(var(--spacer) * 2);
  }
}

.edit-company-error {
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;

  gz-image-repo {
    width: 500px;
    height: auto;
  }
}
